import {
  Flex,
  FlexProps,
  Icon,
  Text,
  HStack,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerHeader,
  DrawerBody,
  DrawerCloseButton,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";
import { TbAlertCircle } from "react-icons/tb";
import { NewHireJourneyId } from "models/newHire";
import { dedupeMissingSlackUsers } from "features/Issues/helpers";
import { useIssuesByNewHireIdQuery } from "features/Issues/hooks";
import IssueModalTag from "../IssueModal";
import { ListIssues } from ".";

interface ListIssuesByNewHireProps extends FlexProps {
  newHireId: NewHireJourneyId;
  fieldProps?: object;
}

export function ListIssuesByNewHire({ newHireId, fieldProps = {}, ...rest }: ListIssuesByNewHireProps) {
  const { data: issues } = useIssuesByNewHireIdQuery(newHireId);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const dedupedIssues = dedupeMissingSlackUsers(issues);
  const numberOfIssues = dedupedIssues?.length || 0;

  if (numberOfIssues === 0) {
    return null;
  }

  return (
    <>
      <Flex
        align="center"
        gap="2"
        bg="red.50"
        border="1px solid"
        borderColor="red.100"
        borderRadius="md"
        px="4"
        py="2.5"
        cursor="pointer"
        onClick={onOpen}
        _hover={{ bg: "red.100" }}
        {...rest}
      >
        <Icon as={TbAlertCircle} boxSize="4" color="red.600" />
        <Text fontSize="sm" fontWeight="600" color="red.600">
          {numberOfIssues} Issue{numberOfIssues > 1 ? "s" : ""}
        </Text>
        <Text fontSize="xs" color="red.400">
          · Click to view and resolve
        </Text>
      </Flex>

      <Drawer isOpen={isOpen} placement="right" onClose={onClose} size="md">
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>
            <HStack spacing={2}>
              <Icon as={TbAlertCircle} boxSize="5" color="red.600" />
              <Text>
                {numberOfIssues} Issue{numberOfIssues > 1 ? "s" : ""}
              </Text>
            </HStack>
          </DrawerHeader>
          <DrawerBody>
            <VStack spacing={3} align="start">
              {dedupedIssues?.map((issue) => (
                <IssueModalTag key={issue.id} issue={issue} />
              ))}
            </VStack>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
}

export function TableColumnListIssuesByNewHire({ newHireId, fieldProps = {}, ...rest }: ListIssuesByNewHireProps) {
  const { data: issues } = useIssuesByNewHireIdQuery(newHireId);
  return <ListIssues issues={dedupeMissingSlackUsers(issues)} />;
}
